module.exports = __webpack_public_path__ + "static/media/info-card.b66298de.svg";